<div class="table-scroll" [class.message]="origin === 'message'">
  <table *ngIf="!error && !loading && conversations && conversations.length > 0; else innerLoading" class="table">
    <thead>
    <tr>
      <th class="patient-name-col" scope="col">Nom du patient</th>
      <th class="subject-col" scope="col">Sujet</th>
      <th class="last-activity-col" scope="col">
        <button (click)="markMessagesAsRead()" *ngIf="displayMarkAsReadButton" [disabled]="loading || updating"
                class="btn btn-link"
                id="mark-all-read-button" type="button">
          <ng-container *ngIf="loading || updating; else markAllReadButton">
            <span aria-hidden="true" class="spinner-grow spinner-grow-sm" role="status"></span>
            <span class="visually-hidden">Chargement...</span>
          </ng-container>
          <ng-template #markAllReadButton>
            <span class="desktop">Tous marquer comme lus</span>
            <span class="mobile">Tous lus</span>
          </ng-template>
        </button>
        <ng-container *ngIf="!displayMarkAsReadButton">Dernière activité</ng-container>
      </th>
    </tr>
    </thead>
    <tbody>
    <tr (click)="openConversation(conversation)" *ngFor="let conversation of conversations"
        [class.active]="conversation === selectedConversation" [initials]="conversation.initials"
        [isClosed]="conversation.closed" [isNew]="conversation.new" [lastActivity]="conversation.lastMessageDate"
        [patientAvatarUrl]="conversation.patientAvatarUrl" [patientId]="conversation.patientId"
        [patientName]="conversation.name" [subject]="conversation.subject"
        msd-message-cell></tr>
    </tbody>
  </table>
</div>

<msd-conversation (messageBack)="messageBack()"
                  (messageForward)="messageForward()"
                  (messageList)="selectedConversation = undefined"
                  *ngIf="selectedConversation"
                  [conversationId]="selectedConversation.id"
                  [isBack]="selectedConversation !== conversations[conversations.length - 1]"
                  [isForward]="selectedConversation !== conversations[0]"
                  [origin]="origin">
</msd-conversation>

<ng-template #innerLoading>
  <ngx-inner-loading (retry)="loadConversations()" [emptyDescription]="emptyMessage"
                     [empty]="conversations?.length === 0"
                     [errorDescription]="'Une erreur est survenue, veuillez réessayer plus tard.'" [error]="!!error"
                     [loadingDescription]="'Chargement...'"
                     [loading]="loading"
                     [retryButtonText]="'Réessayer'"
                     class="flex-center">
  </ngx-inner-loading>
</ng-template>
